module.exports = __webpack_public_path__ + "media/customizations/wellenpark/logo-b0526abf918acf83764e18e13c1a35e1.png";